import $ from "jquery";

export function mandarMailJack(datos, idioma) {
  const plantilla = `<body>
  <div align="center">
  ¡Enhorabuena!
  </div>
  <div align="center">
  Ya diste el primer paso a un nuevo concepto audiovisual. Jack se pondrá en
  contacto contigo para resolver tus dudas.
  </div>
  <div align="center">
  Espera noticias pronto...
  </div> 
  </body>
  `;

  const plantilla2 = `
  <body>
  <div align="center">
     Esta persona se puso en contacto con nosotros
  </div>
  <hr>
  <div>
    <b>Nombre:</b> <br> 
    ${datos.nombre}
  </div>
  <div>
    <b>Email: </b> <br>
    ${datos.correo}
  </div>
  
  <div>
    <b> Mensaje: </b> <br>
     ${datos.mensaje}
  </div>
  
  </body>
  `;

  var mailVisitante = {
    async: true,
    crossDomain: true,
    url: "https://sender-mail-big-pink.herokuapp.com/sendmail",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      from: "jack@lahabichuelamagica.com",
      emailPass: "Habichuelos4049",
      to: datos.correo,
      message: plantilla,
      subject: "",
    },
  };
  $.ajax(mailVisitante).done(function (response) {
    if (response.ok === true) {
      document.getElementById("mensaje-enviado").style.color = "#fff";
      document.getElementById("mensaje-enviado").style.fontFamily = "Andalemo";
      document.getElementById("mensaje-enviado").style.fontSize = "11px";
      if (idioma) {
        document.getElementById("mensaje-enviado").innerHTML =
          "Mensaje enviado";
      } else {
        document.getElementById("mensaje-enviado").innerHTML = "Message sent";
      }
    }
  });

  var mailJack = {
    async: true,
    crossDomain: true,
    url: "https://sender-mail-big-pink.herokuapp.com/sendmail",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      from: "jack@lahabichuelamagica.com",
      emailPass: "Habichuelos4049",
      to: "jack@lahabichuelamagica.com",
      message: plantilla2,
      subject: "",
    },
  };
  $.ajax(mailJack).done(function (response) {
    if (response.ok === true) {
    }
  });
}
